export default "__VITE_ASSET__ChdhWv0I__"